import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { Person } from 'src/app/modules/entities/person';
import { Subscription } from 'src/app/modules/entities/subscription';
import { SubscriptionDetail } from 'src/app/modules/entities/subscription-detail';
import { PersonService } from 'src/app/modules/services/person.service';
import { SubscriptionService } from 'src/app/modules/services/subscription.service';
import { errorDescription, url } from 'src/app/modules/util/constants';

@Component({
  selector: 'app-subscription-detail',
  templateUrl: './subscription-detail.component.html',
  styleUrls: ['./subscription-detail.component.css']
})
export class SubscriptionDetailComponent implements OnInit {

  constructor(private router: Router, private fb: FormBuilder, private route: ActivatedRoute, private personService: PersonService, 
    private messageService: MessageService, private primengConfig: PrimeNGConfig, private subscriptionService: SubscriptionService) {
    this.route.params.subscribe(params => {
      this.setupParams(params['id']);
    });
    this.subscriptionForm = this.fb.group({
      days: [20, [Validators.required]],
      subscription: ['', [Validators.required]],
      additionalNotes: ['', [Validators.maxLength(100)]]
    }) 
  }

  person: Person | undefined = undefined;
  urlId: string | undefined;
  currentDate: Date = new Date();
  subscriptionForm: FormGroup;
  subscriptionList: Subscription[] = [];
  loading: boolean = false;
  displayCreatePayment: boolean = false;
  subscriptionSelected: SubscriptionDetail | undefined;

  ngOnInit(): void {
    this.primengConfig.setTranslation({
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']
    })
    this.subscriptionService.getSubscriptions().subscribe({
      next: response => {
        if (response.status === 'success') {
          this.subscriptionList = response.data;
        }
      }
    });
  }

  setupParams(urlId: string) {
    this.urlId = urlId;
    if (this.urlId) {
      this.personService.getSubscriptionProfile(this.urlId).subscribe({
        next: response => {
          if (response.status === 'success') {
            this.person = response.data as Person;
            this.currentDate = new Date();
          } else {
            this.router.navigate([url['perfil'], this.urlId]);
          }
        }
      });
    }
  }

  createSubscription() {
    this.loading = true;
    let subscription = this.subscriptionList.find(s => s.name === this.subscriptionForm.value['subscription'].name);
    let subscriptionDetail: SubscriptionDetail = {
      subscription: subscription!,
      additionalNotes: this.subscriptionForm.value['additionalNotes'],
      issueDate: new Date()
    }
    this.subscriptionService.postSubscription(subscriptionDetail, this.urlId!, this.subscriptionForm.value['days']).subscribe({
      next: response => {
        if (response.status === 'success') {
          this.setupParams(this.urlId!);
          this.messageService.add({severity: response.status, summary: 'Suscripción registrada con éxito'});
        } else {
          this.messageService.add({severity: response.status, summary: 'Ocurrió un error registrando la suscripción'});
        }
        this.loading = false;
      },
      error: error => {
        this.messageService.add({severity: 'error', detail: errorDescription[error.error.error]});
        this.router.navigate([url['login']]);
      }
    });
  }

  createPayment(subscriptionDetail: SubscriptionDetail) {
    this.subscriptionSelected = subscriptionDetail;
    this.displayCreatePayment = true;
  }

  paymentCreatedListener(event: boolean) {
    if (event)
      this.setupParams(this.urlId!);
  }

}
